module.exports = __webpack_public_path__ + "img/Card_SwordHeavy_Yellow-min.2e83a343.png";